import { atom } from 'jotai';

export const roomListForceRefreshAtom = atom<number>(0);
